import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useEventsService } from '../../../../apis/events/useEventsService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import {
  TEventsApiResponse,
  TEventsMonthWindowFlattened,
} from '../../../../apis/events/events.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentsEventsKey = 'get-students-events-list';

export interface TStudentMonthWindowParams extends TPaginationParams {
  currentMonth: string; // YYYY-MM
  includeSpanning?: boolean;
  mode?: 'window' | 'list';
}

export const useStudentsEventsHook = (
  params: TStudentMonthWindowParams,
  options?: UseQueryOptions<
    TEventsApiResponse | TEventsMonthWindowFlattened,
    TQueryError
  >
): UseQueryResult<
  TEventsApiResponse | TEventsMonthWindowFlattened,
  TQueryError
> => {
  const { getEventsList, getEventsMonthWindow } = useEventsService();

  const queryKey = [getStudentsEventsKey, params];
  const mode = params.mode || 'window';

  return useQuery({
    queryKey,
    queryFn: async () => {
      if (mode === 'window') {
        return getEventsMonthWindow(
          params.currentMonth,
          params.includeSpanning ?? true
        );
      }
      const events = await getEventsList(params);
      return { data: events.data, total: events.total } as TEventsApiResponse;
    },
    enabled: Boolean(params.currentMonth),
    ...options,
  });
};
